import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { updateStep } from '../../../state';
import { useWorkflowValidationContext } from '../../shared';

interface StepNameFieldProps {
  index: number;
}

export const StepNameField: React.FC<StepNameFieldProps> = ({ index }) => {
  const dispatch = useAppDispatch();
  const step = useAppSelector((state) => state.workflow.currentWorkflow?.steps[index]);
  const { errors, showErrors } = useWorkflowValidationContext();

  if (!step) return null;

  const nameErr = showErrors && errors.stepErrors?.[index]?.name;

  return (
    <TextField
      size="small"
      label="Step Name"
      value={step.name}
      onChange={(e) => dispatch(updateStep({ index, updates: { name: e.target.value } }))}
      sx={{ flex: 1 }}
      required
      error={!!nameErr}
      helperText={nameErr || undefined}
    />
  );
};

export default StepNameField;
